import { RootState } from '..'
import { MainObject } from '../reports/types'
import { findItemByUuid } from './questionsSlice'

export const findAnswer = (items: MainObject[], uuid: any): MainObject | null => {
  if (!items || !Array.isArray(items)) {
    return null
  }
  for (const item of items) {
    if (item?.uuid === uuid) {
      return item
    }
    const subitem = findAnswer(item?.subanswers, uuid)
    if (subitem) {
      return subitem
    }
  }
  return null
}

const answerToNewCaseQuestion = (uuid: string) => (state: RootState) => {
  return findItemByUuid(state.questions?.newCaseAnswers, uuid)
}
const newCaseReporter = (state: RootState) => state.questions?.reporting_party
const customFieldsSelector = (state: RootState) => state?.questions.custom_fields
const newCaseVictims = (state: RootState) => state?.questions?.victims
const getVictimAnswer = (victimId: number, answerId: string) => (state: RootState) => {
  const victimAnswers = state.questions?.victimAnswers?.find(victim => victim.victimId === victimId)
  return findAnswer(victimAnswers?.answers as MainObject[], answerId)
}
const newCaseSubjects = (state: RootState) => state?.questions?.subjects
const subjectCustomFieldsSelector = (state: RootState) => state?.questions?.subjectsCustomFields

export default {
  answerToNewCaseQuestion,
  newCaseReporter,
  customFieldsSelector,
  newCaseVictims,
  getVictimAnswer,
  newCaseSubjects,
  subjectCustomFieldsSelector,
}
